import { viewJobNativeModule } from "./ViewJobNativeModule";
import { callPromiseAssert } from "../../shared/util/callPromiseAssert";

export function updateApplyStartCookie<T>(
  jobKey: string,
  sourceAbbreviation: string,
  domain: string,
): Promise<T> {
  return callPromiseAssert(
    viewJobNativeModule()?.updateApplyStartCookie<T>,
    "updateApplyStartCookie",
    jobKey,
    sourceAbbreviation,
    domain,
  );
}
